import React from 'react';

import { Moment } from 'moment/moment';

import { ProfilFourriereViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { DatePicker } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { useUserStore } from 'hooks/UserStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import {
  FicheProfilFourriereBlocFourriere,
  InputPropFourriere,
} from 'types/FicheProfil/FicheProfilGardienFourriere';
import { CSSUtils } from 'utils/CSSUtils';
import { DATE_FORMAT } from 'utils/formats';

import { validateFicheProfilGf } from '../../utils';

function DatePickerDateFinAgrement({
  values,
  isEditable,
  generateRequestDto,
}: InputPropFourriere): React.ReactElement {
  const user = useUserStore();
  const gfController = useApi().GardienFourriereControllerApi;
  const key: keyof FicheProfilFourriereBlocFourriere = 'agreementEndDate';

  return (
    <DatePicker
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: "Date de fin d'agrément",
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: Moment | undefined,
              ): Promise<void> => {
                return validateFicheProfilGf(
                  gfController,
                  ProfilFourriereViolationDtoFormFieldEnum.DATE_AGREMENT_FIN,
                  user.idCorrelationFourriere || '',
                  generateRequestDto({ ...values, [key]: value }),
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
        editable: isEditable,
      }}
      datePickerProps={{
        style: { width: '100%' },
        placeholder: FormPlaceholders.Date,
        format: DATE_FORMAT,
      }}
    />
  );
}

export default DatePickerDateFinAgrement;
